import { render } from "./UserStoryMapping.vue?vue&type=template&id=76a60183&scoped=true"
import script from "./UserStoryMapping.vue?vue&type=script&lang=js"
export * from "./UserStoryMapping.vue?vue&type=script&lang=js"

import "./UserStoryMapping.vue?vue&type=style&index=0&id=76a60183&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a60183"]])

export default __exports__